import { Form, Radio } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BudgetingMethod } from '../../../../../budgeting/financialStatements/components/budget/types'

const radioStyle = {
  display: 'block'
}

const BudgetingInputFields = () => {
  const { t } = useTranslation()

  return (
    <div>
      <Form.Item
        name={['budgeting', 'baseLine']}
        rules={[{ required: true }]}
        style={{ maxWidth: 'none' }}
        label={t('budgetingInputPage:income-budgeting-balance')}
      >
        <Radio.Group>
          <Radio style={radioStyle} value="none">
            {t('budgetingInputPage:use-none')}
          </Radio>
          <Radio style={radioStyle} value="lastClosedFiscalYear">
            {t('budgetingInputPage:use-last-closed')}
          </Radio>
        </Radio.Group>
      </Form.Item>
      {/* TODO: Poista tämä piilotettu kenttä sitten kun backend ei enää vaadi method-kenttää */}
      <Form.Item
        name={['budgeting', 'method', 'method']}
        rules={[{ required: true }]}
        style={{ display: 'none' }}
        initialValue={BudgetingMethod.absolute}
      >
        <Radio.Group>
          <Radio value={BudgetingMethod.absolute}>Absolute</Radio>
        </Radio.Group>
      </Form.Item>
    </div>
  )
}

export default BudgetingInputFields
